module.exports = __webpack_public_path__ + "img/borderStarWhite.c1fe2f09.svg";